<template>
  <div class="ima-logo">
    <img class="image" src="@/assets/image/authentication/ima_plus_white.png" alt="Logo IMA Alagoas">
  </div>
</template>

<script>
export default {
  name: 'ImaLogo',
};
</script>

<style scoped lang="scss">
.ima-logo {
  > .image {
    width: 120px;
  }
}
</style>
